<template>
    <div class="navbar-container">
        <ul class="navbar">
            <li>
                <a style="color: rgba(229, 129, 153, 1)" :href="'#top'" class="nabvar-logo"> a&a </a>
            </li>
            <span class="content">
                <li v-for="menu in menus" :key="menu.title">
                    <a :href="menu.link"> {{ menu.title }} </a>
                </li>
            </span>
            <span class="bars">
                <li  @click.prevent="activeSmMenu = !activeSmMenu">
                    <a href=""> <i class="fas fa-bars"/> </a>
                </li>
            </span>
        </ul>
        <div class="content-sm" v-if="activeSmMenu">
            <a v-for="menu in menus" :key="menu.title" :href="menu.link" @click="closeNavbar()"> {{ menu.title }} </a>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            activeSmMenu: false,
            menus: [
                { title: 'Recepción', link: '#recepcion' },
                { title: 'Ceremonia religiosa', link: '#ceremonia' },
                { title: 'Agenda', link: '#agenda' },
                { title: 'Sesión de fotos', link: '#fotos' },
                { title: 'Preguntas frecuentes', link: '#preguntas' },
                { title: 'Regalos', link: '#regalos' },
            ]
        }
    },
    methods : {
        closeNavbar() {
            this.activeSmMenu = false;
        }
    }

}
</script>

<style lang="scss" scoped>
    
@import "./variables.scss";

li {
    float: left;
    list-style-type: none;
    a {
        display: block;
        color: white;
        padding: 14px 16px;
        text-align: center;
        text-decoration: none;
        &:hover {
            background-color: #111;
        }
    }
}

.content {
    flex: 1;
    display: flex;
    margin-left: -68px;
    justify-content: center;
    @media screen and (max-width: $break-mdlg) {
        display: none;
    }
}

.content-sm {
    width: 100%;
    display: flex;
    position: absolute;
    flex-direction: column;
    background-color: #333;
    a {
        color: white;
        text-decoration: none;
        margin: 10px;
    }
}

.bars {
    flex: 1;
    display: none;
    justify-content: flex-end;
    @media screen and (max-width: $break-mdlg) {
        display: flex;
    }
}

.navbar {
    margin: 0;
    padding: 0;
    z-index: 100;
    display: flex;
    overflow: hidden;
    background-color: #333;
}

.navbar-container {
    top: 0;
    z-index: 100;
    font-size: 20px;
    position: sticky;
    font-weight: 100;
    font-family: 'Dancing Script';
}

.nabvar-logo {
    font-size: 35px;
    padding: 0 10px 0 10px;
    color: #707070;
    font-family: 'playlistscript', Arial, sans-serif;
    &:hover {
        color: white;
    }
}

</style>
